<h3 mat-dialog-title [align]="'center'">Gruppe: {{ gruppe?.bezeichnung }} - Kunde: {{ gruppe?.kunde }}</h3>
<div mat-dialog-content [align]="'center'">
    <button
        mat-stroked-button
        color="accent"
        (click)="umstallen()"
        class="dialog-button"
        [attr.data-cy]="'agsgspdgspd_button_1_0_'"
    >
        <mat-icon [attr.data-cy]="'agsgspdgspd_mat-icon_1_2_'">login</mat-icon>
        Umstallen
    </button>
    <button
        mat-stroked-button
        color="accent"
        (click)="ausstallen()"
        class="dialog-button"
        [attr.data-cy]="'agsgspdgspd_button_2_0_'"
    >
        <mat-icon [attr.data-cy]="'agsgspdgspd_mat-icon_2_2_'">logout</mat-icon>
        Ausstallen
    </button>
    <button
        mat-stroked-button
        color="accent"
        (click)="schlachten()"
        class="dialog-button"
        [attr.data-cy]="'agsgspdgspd_button_3_0_'"
    >
        <mat-icon [attr.data-cy]="'agsgspdgspd_mat-icon_3_2_'">restaurant</mat-icon>
        Schlachten
    </button>
    <button
        mat-stroked-button
        color="accent"
        (click)="todMelden()"
        class="dialog-button"
        [attr.data-cy]="'agsgspdgspd_button_4_0_'"
    >
        <mat-icon [attr.data-cy]="'agsgspdgspd_mat-icon_4_2_'">event_busy</mat-icon>
        Todmelden
    </button>
    <button
        mat-stroked-button
        color="accent"
        (click)="gruppenInfo()"
        class="dialog-button"
        [attr.data-cy]="'agsgspdgspd_button_5_0_'"
    >
        <mat-icon [attr.data-cy]="'agsgspdgspd_mat-icon_5_2_'">info</mat-icon>
        GruppenInfo
    </button>
</div>
<div mat-dialog-actions align="end">
    <button mat-button (click)="dialogRef.close()" [attr.data-cy]="'agsgspdgspd_button_6_0_'">Schließen</button>
</div>
